module.exports = __webpack_public_path__ + "img/arrow_right.bc64f5f2.png";